// ----------------------------------------------------------------------
// <copyright file="Izenda.Dashboard.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var Tree = require('../Tree/Izenda.Tree');
  var Panel = require('share/components/controls/Izenda.Panel');
  var observer = require('mobx-react').observer;
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');

  var SearchBox = connect()(function (props) {
    function onChange(e) {
      props.workspaceDetail.dashboardFilterText = e.target.value;
    }

    return <SearchTextBox className='search-box'
      value={props.workspaceDetail.dashboardFilterText}
      onChange={onChange} />
  });

  var Dashboard = React.createClass({
    propTypes: {
      workspaceDetail: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var localization = props.localization;
      var workspaceDetail = props.workspaceDetail;

      return (
        workspaceDetail.copyDashboard &&
        <div className='u_tableCell u_paddingRight'>
          {localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_PLEASE_SELECT_DASHBOARD')}
          <Panel className='u_borderAll workspace-tree u_noMarginAll'>
            <SearchBox workspaceDetail={workspaceDetail} />
            <div className='izenda-dashboardContainer'>
              <Tree
                data={workspaceDetail.sourceDashboards}
                dataPrev={workspaceDetail.sourceDashboardsPrev}
                filterText={workspaceDetail.dashboardFilterText}
                resetPrevData={workspaceDetail.resetDashboardPrevData.bind(workspaceDetail)}
                resetWorkspaceTenantsStatus={workspaceDetail.resetWorkspaceTenantsStatus.bind(workspaceDetail)}
                leafKey='dashboards'
                />
            </div>
          </Panel>
        </div>
      );
    }
  });

  module.exports = observer(connect()(Dashboard));
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/SourceDestination/Dashboard/Izenda.Dashboard.jsx